import { render, staticRenderFns } from "./ThirdParty.vue?vue&type=template&id=610f98f0&scoped=true"
import script from "./ThirdParty.vue?vue&type=script&lang=js"
export * from "./ThirdParty.vue?vue&type=script&lang=js"
import style0 from "./ThirdParty.vue?vue&type=style&index=0&id=610f98f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f98f0",
  null
  
)

export default component.exports